import { MarketingNav, Footer } from "@/components/marketing/MarketingNav";
import { Link } from "react-router-dom";
import { AurumOrb } from "@/components/brand/AurumOrb";
import { ArrowRight } from "lucide-react";

const STEPS = [
  ["01", "Build your plan", "Answer a short onboarding: experience, goal, style, account size, risk limits, session and strategy. Aurum generates your trading plan."],
  ["02", "Aurum monitors Gold", "XAU/USD data flows through data-quality checks, regime detection, higher-timeframe context and key levels — continuously."],
  ["03", "A setup is evaluated", "The strategy router activates the right approach. Aurum checks confirmation, news, volatility and spread, then argues against the trade."],
  ["04", "Risk is calculated", "Structure-based stop, logical targets, exact position size and max planned loss — all before you act."],
  ["05", "You review & approve", "Work through the pre-trade checklist, accept that the trade can lose, and approve a paper execution."],
  ["06", "Aurum learns with you", "Every trade is journaled automatically. Analytics and the AI coach help you improve your process over time."],
];

export default function HowItWorks() {
  return (
    <div className="bg-[var(--bg)] text-[var(--text)] min-h-screen">
      <MarketingNav />
      <section className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="flex items-center gap-4">
          <AurumOrb status="ANALYZING" size={64} />
          <div>
            <span className="text-xs uppercase tracking-wider text-aurum font-medium">How it works</span>
            <h1 className="mt-1 text-4xl lg:text-5xl font-extrabold tracking-tight">From plan to journal.</h1>
          </div>
        </div>
        <div className="mt-14 relative">
          <div className="absolute left-[27px] top-2 bottom-2 w-px bg-[var(--border2)] hidden sm:block" />
          <div className="space-y-8">
            {STEPS.map(([n, t, d]) => (
              <div key={n} className="flex gap-5">
                <div className="relative z-10 h-14 w-14 shrink-0 rounded-full border border-[var(--border2)] bg-[var(--card2)] flex items-center justify-center tnum font-bold text-aurum">{n}</div>
                <div className="pt-1"><h3 className="text-lg font-semibold">{t}</h3><p className="mt-1 text-sm text-[var(--text-sec)] max-w-xl">{d}</p></div>
              </div>
            ))}
          </div>
        </div>
        <Link to="/signup" className="mt-14 inline-flex items-center gap-2 btn-gold rounded-full px-6 py-3 text-sm font-semibold hover:brightness-110">Try it free <ArrowRight size={16} /></Link>
      </section>
      <Footer />
    </div>
  );
}
